import { getScreenName } from '../../Utils/helper';

import { fireEvent } from '../../Utils/fireEvent';

export const calculatePaddingTop = (imageRatio) => {
  if (!imageRatio) return null;
  const [width, height] = imageRatio.split(':');
  return `${(100 / width) * height}%`;
};

export const addCommaText = (numberStr) => {
  if (!/^\d+$/.test(numberStr)) {
    return 'Invalid input, please provide a valid number string.';
  }

  // Reverse the string to make it easier to insert commas
  const reversedStr = numberStr.split('').reverse().join('');

  // Use regular expression to insert commas with custom pattern
  const commaAddedStr = reversedStr.replace(
    /\d{1,3}(?=\d{2}|$)/g,
    (match) => match + ',',
  );

  // Reverse the result back to the original order and remove trailing comma
  const resultStr = commaAddedStr
    .split('')
    .reverse()
    .join('')
    .replace(/^,/, '');

  return resultStr;
};

export const fireClickedCategoryCardEvent = (data) => {
  fireEvent({
    ...data,
    category: 'clicked_card_in_general_screen',
    screen_name: getScreenName(),
  });
};

export const getDesktopImage = (product) => {
  return product?.desktopImage || product?.image || product?.mobileWebImage;
};
export const getMobileImage = (product) => {
  return product?.mobileWebImage || product?.image || product?.desktopImage;
};

export const placholderImageConstant = {
  '2662:378':
    'https://images.myloapp.in/NestJsUploads/1705991481541-2662-x-378.svg',
  '9:2': 'https://images.myloapp.in/NestJsUploads/1705991481545-9x2.svg',
  '190:27':
    'https://images.myloapp.in/NestJsUploads/1705991481545-190-x-27.svg',
  '243:100':
    'https://images.myloapp.in/NestJsUploads/1705991481546-243-x-100.svg',
};
